// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__IOGQW"};